import Layout from "../../components/layout/Layout";
import styles from '../LandingPage/LandingPage.module.css';
import { connect } from "react-redux";
import StoreroomRequestList from "../../components/requests/StoreroomRequestList";




const AdminLandingPage = () => {
  return (
    <Layout>
      <main className={styles.storeroom}>
       <StoreroomRequestList/>
      </main>
    </Layout>
  );
}

const mapStateToProps = state => ({
  isAuthenticated: state.Auth.isAuthenticated,
  user: state.Auth.user,
})
export default connect(mapStateToProps, {

})(AdminLandingPage);